<mat-dialog-content class="order-log-dialog-content">
  <mat-list role="list" dense>
    <mat-list-item
      role="listitem"
      *ngFor="let log of sortedLogs"
      class="order-log-row"
    >
      <span class="log-row">
        <ng-container *ngIf="log.item">{{ formatLogItem(log.item) }}&nbsp;&ndash;&nbsp;</ng-container>
        {{ log.initials }}
        &nbsp;&ndash;&nbsp;{{ log.date | date: 'MM/dd/yyyy': 'PST' }}
        <ng-container *ngIf="log.notes">&nbsp;&ndash;&nbsp;{{ log.notes }}</ng-container>
      </span>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
